import { runInAction } from "mobx";
import { dashboardService } from "../services/dashboard.service";
import { dashboardFiltersStore } from "../stores/filters.store";
import { dashboardConsolidatedMetricDetailStore } from "../stores/consolidated-metric-detail.store";
import { buildDashboardScopePayload } from "../utils/dashboard-request-scope";
import { resolveSelectedReportingPeriod } from "../utils/reporting-years";

export const loadConsolidatedMetricDetailForPanel = async (key) => {
  const store = dashboardConsolidatedMetricDetailStore;
  const panel = store.getPanel(key);
  if (!panel || !panel.pivot) return;

  const { years, frameworks, categories } = dashboardFiltersStore.filters;
  const { disclosureId, year } = panel.pivot;
  const { drillOrgIds, statuses, search, page, pageSize } = panel;

  const scopedYears = year != null ? [year] : years;
  const reportingPeriod = resolveSelectedReportingPeriod(
    scopedYears,
    dashboardFiltersStore.available.reportingYears,
  );

  panel.setLoading(true);
  try {
    const data = await dashboardService.getConsolidatedMetricDetail({
      years: scopedYears,
      ...(reportingPeriod || {}),
      frameworks,
      categories,
      ...buildDashboardScopePayload({
        filters: dashboardFiltersStore.filters,
        orgTree: dashboardFiltersStore.available.orgTree,
      }),
      disclosureId,
      drillOrgIds,
      statuses,
      search,
      page,
      pageSize,
    });
    runInAction(() => {
      if (store.isExpanded(key)) {
        panel.setResult(data);
      }
    });
  } finally {
    panel.setLoading(false);
  }
};

export const loadAllConsolidatedMetricDetails = async () => {
  const store = dashboardConsolidatedMetricDetailStore;
  const keys = Array.from(store.expandedKeys);
  await Promise.all(
    keys.map((key) => loadConsolidatedMetricDetailForPanel(key)),
  );
};
